// extracted by mini-css-extract-plugin
export default {"img":"gallery_img__yOuVR"};